// eslint-disable-next-line no-shadow
export enum ChartView {
  // eslint-disable-next-line no-unused-vars
  vendor = 'vendorCount',
  // eslint-disable-next-line no-unused-vars
  spend = 'totalSpend',
}
